import React, { useEffect } from "react";
import { Modal, Form, InputNumber, Button, Divider } from "antd";
import { TrophyOutlined, SaveOutlined } from "@ant-design/icons";
import "./updateReelRankingPopup.css";

const RankingEditModal = ({
  visible,
  onClose,
  projectData,
  onSave,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && projectData) {
      form.setFieldsValue({
        ranking: projectData.ranking || null,
      });
    } else if (visible) {
      form.resetFields();
    }
  }, [visible, projectData, form]);

  const handleFinish = (values) => {
    const payload = {
      reel_id: projectData?._id,
      project_id: projectData?.project?.project_id,
      ranking: Number(values.ranking),
    };

    onSave(payload);
  };

  const thumbnail = projectData?.videos?.[0]?.thumbnail;

  return (
    <Modal
      title={
        <div className="ranking-edit-modal-header-content">
          <TrophyOutlined
            className="ranking-edit-modal-header-icon"
            style={{ color: "white" }}
          />
          <span style={{ color: "white" }}>UPDATE REELS RANKING</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={600}
      className="ranking-edit-modal-override"
      styles={{
        header: {
          background: "#0D152B",
          borderRadius: "12px 12px 0 0",
          padding: "20px 24px",
          borderBottom: "none",
        },
        body: {
          padding: "24px",
          background: "#fafafa",
        },
      }}
    >
      <div className="ranking-edit-modal-form">
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <div className="ranking-edit-section">
            <h3 className="ranking-edit-section-header">Reel Information</h3>

            <div className="builder-info-display">

              {/* Thumbnail Preview */}
              {thumbnail && (
                <div className="builder-info-item builder-info-item--thumbnail">
                  <span className="builder-info-label">Preview:</span>
                  <div className="reel-thumbnail-wrapper">
                    <img
                      src={thumbnail}
                      alt="Reel thumbnail"
                      className="reel-thumbnail"
                    />
                    <span className="reel-thumbnail-badge">
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="white">
                        <polygon points="2,1 9,5 2,9" />
                      </svg>
                      Video
                    </span>
                  </div>
                </div>
              )}

              <div className="builder-info-item">
                <span className="builder-info-label">Project Name:</span>
                <span className="builder-info-value">
                  {projectData?.project?.project_name || "N/A"}
                </span>
              </div>

              <div className="builder-info-item">
                <span className="builder-info-label">Project ID:</span>
                <span className="builder-info-value builder-info-value--mono">
                  {projectData?.project?.project_id || "N/A"}
                </span>
              </div>

              {/* <div className="builder-info-item">
                <span className="builder-info-label">Reel ID:</span>
                <span className="builder-info-value builder-info-value--mono">
                  {projectData?._id || "N/A"}
                </span>
              </div> */}

              <div className="builder-info-item">
                <span className="builder-info-label">Business Type:</span>
                <span className="builder-info-value">
                  <span className="business-type-badge">
                    {projectData?.business_type || "N/A"}
                  </span>
                </span>
              </div>

              {/* <div className="builder-info-item">
                <span className="builder-info-label">City:</span>
                <span className="builder-info-value">
                  {projectData?.city?.city_name || "N/A"}
                </span>
              </div>

              <div className="builder-info-item">
                <span className="builder-info-label">State:</span>
                <span className="builder-info-value">
                  {projectData?.state?.state_name || "N/A"}
                </span>
              </div>

              <div className="builder-info-item">
                <span className="builder-info-label">Country:</span>
                <span className="builder-info-value">
                  {projectData?.country?.country_name || "N/A"}
                </span>
              </div> */}

              <div className="builder-info-item">
                <span className="builder-info-label">Current Ranking:</span>
                <span className="builder-info-value builder-current-rank">
                  {projectData?.ranking ? `#${projectData.ranking}` : "Not Set"}
                </span>
              </div>

            </div>
          </div>

          <Divider className="ranking-edit-divider" />

          <div className="ranking-edit-section">
            <h3 className="ranking-edit-section-header">Update Ranking</h3>

            <Form.Item
              label="New Ranking Position"
              name="ranking"
              rules={[
                { required: true, message: "Please input ranking" },
                {
                  validator: (_, value) => {
                    if (value === undefined || value === null || value === "") {
                      return Promise.reject("Please input ranking");
                    }
                    if (Number(value) < 1) {
                      return Promise.reject("Ranking must be at least 1");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber
                size="large"
                placeholder="Enter ranking position"
                className="ranking-edit-input-override"
                style={{ width: "100%" }}
                min={1}
                max={10000}
              />
            </Form.Item>

            <p className="ranking-helper-text">
              Enter a number to set the reel ranking position
            </p>
          </div>

          <Form.Item style={{ marginBottom: 0 }}>
            <div className="ranking-edit-actions">
              <Button
                size="large"
                onClick={onClose}
                className="ranking-edit-btn ranking-edit-btn-cancel"
              >
                Cancel
              </Button>

              <Button
                htmlType="submit"
                size="large"
                icon={<SaveOutlined />}
                className="ranking-edit-btn ranking-edit-btn-primary ranking-edit-btn-override"
              >
                <span>Update Ranking</span>
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default RankingEditModal;